import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DialogService } from '../services/dialog.service';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const dialogService = inject(DialogService);
  const router = inject(Router);

  // ตรวจสอบว่า user authenticated หรือไม่
  if (authService.isAuthenticated()) {
    // ถ้าเป็น local user (ไม่ใช่ OAuth/Demo) ให้ตรวจสอบ token expiry
    const user = authService.getCurrentUser();
    if (user && user.provider !== 'google' && user.provider !== 'facebook' && user.provider !== 'demo') {
      // ถ้า token หมดอายุ ให้แสดง popup และ logout
      if (authService.isTokenExpired()) {
        console.warn('🔐 Token expired detected in AuthGuard');
        // แสดง popup แจ้งเตือน
        await dialogService.showTokenExpiredDialog();
        // Logout และ redirect ไป login
        authService.logoutSync();
        router.navigate(['/login'], { 
          queryParams: { returnUrl: state.url, reason: 'session_expired' } 
        });
        return false;
      }
    }
    return true;
  }

  // ถ้าไม่ได้ login ให้ redirect ไป login page พร้อม return URL
  router.navigate(['/login'], { 
    queryParams: { returnUrl: state.url } 
  });
  return false;
};

// Guard สำหรับหน้าที่ไม่ต้อง login (เช่น login page)
export const GuestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  // ถ้า login แล้ว ให้ redirect ไป dashboard
  router.navigate(['/dashboard']);
  return false;
};
